module.exports = __webpack_public_path__ + "img/master.90d6634f.png";